/*
 * -----------------------------------------------------------------------
 *  <copyright file="edit-study-site-overview-config.helper.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import i18n from 'i18next';
import {
    IStudyOverviewData,
    IStudySiteOverviewData,
    // eslint-disable-next-line max-len
} from '@components/admin/studies/study-settings-dialogs/edit-overview-tables/edit-study-site-overview-config/edit-study-site-overview-config.interface';
import { StudyFields } from '@queries/generated/fragments.generated';

export const formStudyOverviewData = (study: StudyFields): IStudyOverviewData => ({
    displayStudyOverviewOnStudySummary: study.displayStudyOverviewOnStudySummary,
    studyOverviewTableConfigurationInputType: {
        columnConfigurations: study?.studyOverviewTableConfiguration?.columnConfigurations?.length
            ? study.studyOverviewTableConfiguration.columnConfigurations.map((item) => ({
                  calculation: item?.calculation,
                  dataSource: item?.dataSource,
                  type: item?.type,
                  fields: item?.fields,
                  name: item?.name,
                  order: item?.order,
                  default: item?.default,
              })) || []
            : [
                  {
                      type: null,
                      calculation: null,
                      dataSource: null,
                      fields: null,
                      name: i18n.t('admin:defaultPanelColumns'),
                      order: 1,
                      default: true,
                  },
              ],
        panelConfigurations:
            study?.studyOverviewTableConfiguration?.panelConfigurations?.map((item) => ({
                panelId: item?.panelId,
                panelOrder: item?.panelOrder,
            })) || [],
    },
});

export const formSiteOverviewData = (study: StudyFields): IStudySiteOverviewData => ({
    displayStudySiteOverviewOnStudySummary: study.displayStudySiteOverviewOnStudySummary,
    studySiteOverviewTableConfigurationInputType: {
        columnConfigurations: study?.studySiteOverviewTableConfiguration?.columnConfigurations?.length
            ? study.studySiteOverviewTableConfiguration.columnConfigurations.map((item) => ({
                  calculation: item?.calculation,
                  dataSource: item?.dataSource,
                  type: item?.type,
                  fields: item?.fields,
                  name: item?.name,
                  order: item?.order,
                  default: item?.default,
              })) || []
            : [
                  {
                      type: null,
                      calculation: null,
                      dataSource: null,
                      fields: null,
                      name: i18n.t('admin:defaultPanelColumns'),
                      order: 1,
                      default: true,
                  },
              ],
        panelConfigurations:
            study?.studySiteOverviewTableConfiguration?.panelConfigurations?.map((item) => ({
                panelId: item?.panelId,
                panelOrder: item?.panelOrder,
            })) || [],
        rowOrder: study.studySiteOverviewTableConfiguration?.rowOrder,
    },
});
